import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    livingOptions: [],
    subsectionGroups: [],
    subsections: [],
    properties: [],
    dwellings: [],
    packages: [],
    turnkeys: [],

    activeSlideId: '',

    activeVirtualTourUrl: ''
  },

  mutations: {
    SET_LIVING_OPTIONS (state, livingOptions) {
      state.livingOptions = livingOptions
    },

    SET_SUBSECTION_GROUPS (state, subsectionGroups) {
      state.subsectionGroups = subsectionGroups
    },

    SET_SUBSECTIONS (state, subsections) {
      state.subsections = subsections
    },

    SET_PROPERTIES (state, properties) {
      state.properties = properties
    },

    SET_DWELLINGS (state, dwellings) {
      state.dwellings = dwellings
    },

    SET_TURNKEYS (state, turnkeys) {
      state.turnkeys = turnkeys
    },
    
    SET_PACKAGES (state, packages) {
      state.packages = packages
    },

    SET_ACTIVE_SLIDE_ID: (state, id) => {
      state.activeSlideId = id
    },

    SET_ACTIVE_VIRTUAL_TOUR_URL: (state, id) => {
      state.activeVirtualTourUrl = id
    },
  },

  getters: {
    activeSlide: (state) => {
      const slide = state.packages.find(_package => _package._id === state.activeSlideId)

      if (slide) {
        return slide

      } else {
        return null
      }
    },

    activeLivingOption: (state, getters, rootState) => {
      const livingOptionId = rootState.route.params.livingOptionId

      if (livingOptionId) {
        return _.find(getters.livingOptions, livingOption => {
          return livingOption._id === livingOptionId
        })
      } else {
        return null
      }
    },

    activeLivingOptionSubsections (state, getters, rootState) {
      const routeName = rootState.route.name

      if (['living-option', 'subsection'].includes(routeName)) {        
        return _.sortBy(getters.activeSubsections, subsection => {
          return subsection.marker.x
        })
      }
      
      return []
    },

    activeLivingOptionProperties (state, getters, rootState) {
      const routeName = rootState.route.name

      if (['subsection', 'property'].includes(routeName)) {
        return _.sortBy(getters.activeProperties, property => {
          return property.marker.x + property.marker.y
        })
      }
      
      return []
    },

    activeLivingOptionTags (state, getters, rootState) {
      const routeName = rootState.route.name
      const pathway = rootState.route.params.pathway

      if (['living-entry'].includes(routeName)) {
        if (pathway === 'land') {
          return _.sortBy(getters.livingOptionsLand, livingOption => {
            return livingOption.marker.x
          })
        }

        if (pathway === 'townhouses') {
          return _.sortBy(getters.livingOptionsTownhouses, livingOption => {
            return livingOption.marker.x
          })
        }

        if (pathway === 'apartments') {
          return _.sortBy(getters.livingOptionsApartments, livingOption => {
            return livingOption.marker.x
          })
        }

        if (pathway === 'houses') {
          return _.sortBy(getters.livingOptionsHouses, livingOption => {
            return livingOption.marker.x
          })
        }
      }
      
      return []
    },

    activeProperty: (state, getters, rootState) => {
      if (rootState.route.params.propertyId) {
        return _.find(getters.properties, property => {
          return property._id === rootState.route.params.propertyId
        })
      } else {
        return null
      }
    },

    activeProperties: (state, getters) => {
      return getters.activeSubsection ? getters.activeSubsection.properties : []
    },

    activeSubsection: (state, getters, rootState) => {      
      if (rootState.route.params.subsectionId) {
        return _.find(getters.subsections, subsection => {
          return subsection._id === rootState.route.params.subsectionId
        })
      } else {
        return null
      }
    },

    activeSubsectionGroup: (state, getters, rootState) => {      
      if (rootState.route.params.subsectionGroupId) {
        return _.find(state.subsectionGroups, subsection => {
          return subsection._id === rootState.route.params.subsectionGroupId
        })
      } else {
        return null
      }
    },

    activeSubsections: (state, getters, rootState) => {      
      const pathway = rootState.route.params.pathway

      let activeSubsections = []

      if (getters.activeSubsection) {
        getters.activeSubsection.subsectionIds.forEach(subsectionId => {
          const activeSubsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId && subsection.type === pathway })
          if (activeSubsection) {
            activeSubsections.push(activeSubsection)
          }
        })
  
        return activeSubsections
      }

      if (getters.activeLivingOption) {
        getters.activeLivingOption.subsectionIds.forEach(subsectionId => {
          const activeSubsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId && subsection.type === pathway })
          if (activeSubsection) {
            activeSubsections.push(activeSubsection)
          }
        })
  
        return activeSubsections
      }

      return []
    },

    activeVirtualTourUrl: (state) => {
      return state.activeVirtualTourUrl
    },

    livingOptions: (state, getters) => {
      if (state.livingOptions && state.livingOptions.length && getters.subsections.length) {
        let livingOptions = JSON.parse(JSON.stringify(state.livingOptions))
        // livingOptions = _.filter(livingOptions, livingOption => { return livingOption.active && !livingOption.isVisuallyHidden })
        livingOptions = _.filter(livingOptions, livingOption => { return livingOption.active })

        // lets find all the subsections nested in each living option
        livingOptions.forEach(livingOption => {
          let subsectionIds = []
          let nestedSubsections = []
          let nestedProperties = []

          // filter types
          let bathRanges = []
          let bedRanges = []
          let carRanges = []
          let lotNumbers = []
          let landPriceRanges = []
          let dwellingPriceRanges = []
          let propertyTypes = []
          let sizeRanges = []
          let dwellingSizeRanges = []

          if (livingOption.subsections) {
            livingOption.subsectionIds.forEach(subsectionId => {
              let livingOptionSubsections = []
              subsectionIds.push(subsectionId)

              livingOptionSubsections = getters.subsections.filter(subsection => {
                if (subsectionIds.includes(subsection._id)) {
                  return subsection
                }
              })

              livingOptionSubsections.forEach(subsection => {
                nestedSubsections.push(...recursiveSubsections(subsection, getters.subsections))

                bathRanges.push(...subsection.filter.bathRange)
                bedRanges.push(...subsection.filter.bedRange)
                carRanges.push(...subsection.filter.carRange)
                lotNumbers.push(...subsection.filter.lotNumbers)
                landPriceRanges.push(...subsection.filter.landPriceRange)
                if (subsection.filter.dwellingPriceRange) {                  
                  dwellingPriceRanges.push(...subsection.filter.dwellingPriceRange)
                }
                
                if (subsection.filter.dwellingSizeRange) {
                  dwellingSizeRanges.push(...subsection.filter.dwellingSizeRange)
                }

                propertyTypes.push(...subsection.filter.propertyTypes)
                sizeRanges.push(...subsection.filter.sizeRange)
              })
            })
          }
          
          // get all the properties attached to each subsection
          nestedSubsections.forEach(subsection => {
            if (subsection.properties) {
              nestedProperties.push(...subsection.properties)
            }
          })

          nestedProperties = _.uniq(nestedProperties)

          livingOption.nestedProperties = nestedProperties

          // get count of available properties
          livingOption.availableProperties = nestedProperties.filter(property => property.active && property.status !== 'Sold').length

          // add living option filtering from subsections
          livingOption.filter = {
            bathRange: [ Math.min(...bathRanges), Math.max(...bathRanges) ],
            bedRange: [ Math.min(...bedRanges), Math.max(...bedRanges) ],
            carRange: [ Math.min(...carRanges), Math.max(...carRanges) ],
            lotNumbers: _.uniq(lotNumbers),
            landPriceRange: [ Math.min(...landPriceRanges), Math.max(...landPriceRanges) ],
            dwellingPriceRange: [ Math.min(...dwellingPriceRanges), Math.max(...dwellingPriceRanges) ],
            propertyTypes: _.uniq(propertyTypes),
            sizeRange: [ Math.min(...sizeRanges), Math.max(...sizeRanges) ],
            dwellingSizeRange: [ Math.min(...dwellingSizeRanges), Math.max(...dwellingSizeRanges) ],
          }
        })

        return livingOptions
      } else {
        return []
      }
    },

    livingOptionsApartments: (state, getters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          const subsections = livingOption.subsections

          console.log('subsections',subsections)
          
          
          if (subsections) {
            let isApartment = false

            subsections.forEach(subsection => {
              if (subsection.type === 'apartments') {
                isApartment = true
              }
            })

            return isApartment
          }
        })
      } else {
        return []
      }
    },

    livingOptionsHouses: (state, getters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          const subsections = livingOption.subsections
          
          if (subsections) {
            let isHouse = false

            subsections.forEach(subsection => {
              if (subsection.type === 'houses') {
                isHouse = true
              }
            })

            return isHouse
          }
        })
      } else {
        return []
      }
    },

    livingOptionsLand: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'land') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availableProperties === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsTownhouses: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'townhouses') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availableProperties === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsPackages: (state, getters, rootState) => {
      const filter = rootState.filter
      let packages = JSON.parse(JSON.stringify(state.packages))
      if (rootState.styleTemplate['general']['show-packages-with-sold-lots']) {
        packages = _.filter(packages, _package => { return _package.active })
      } else {
        packages = _.filter(packages, _package => { return _package.active && _package.property.status !== 'Sold' })
      }

      packages.forEach(_package => {
        _package.filter = false
        
        // filter package price
        const packagePrice = _package.price / 1000

        if (filter.inputPriceRange[0] > packagePrice || filter.inputPriceRange[1] < packagePrice) {
          _package.filter = true
        }

        // filter package.property / package.dwelling sizes
        // ignore filter if value is null
        const packageLandSize = _package.property.size
        const packageDwellingSize = _package.dwelling.size

        if (packageLandSize && filter.inputLotSizeRange[0] > packageLandSize || filter.inputLotSizeRange[1] < packageLandSize) {
          _package.filter = true
        }

        if (packageDwellingSize && filter.inputDwellingSizeRange[0] > packageDwellingSize || filter.inputDwellingSizeRange[1] < packageDwellingSize) {
          _package.filter = true
        }

        // filter package.property lot number
        // TODO use lot number field instead
        const packagePropertyNumber = _package.property.label.replace(/[^\d.]/g, '')

        if (filter.inputLotNumber && filter.inputLotNumber !== packagePropertyNumber) {
          _package.filter = true
        }

        // filter beds
        const packageBeds = parseInt(_package.dwelling.beds)
        if (filter.inputBeds && filter.inputBeds !== packageBeds) {
          _package.filter = true
        }

        // filter baths
        const packageBaths = parseInt(_package.dwelling.baths)
        if (filter.inputBaths && filter.inputBaths !== packageBaths) {
          _package.filter = true
        }

        // filter cars
        const packageCars = parseInt(_package.dwelling.cars)
        if (filter.inputCars && filter.inputCars !== packageCars) {
          _package.filter = true
        }

        if (filter.inputBuilder && filter.inputBuilder.toLowerCase() !== _package.dwelling.builderLabel.toLowerCase()) {
          _package.filter = true
        }

        if (filter.inputColourScheme && filter.inputColourScheme.toLowerCase() !== _package.dwelling.colourScheme.toLowerCase()) {
          _package.filter = true
        }

        if (filter.inputHouseDesign && filter.inputHouseDesign.toLowerCase() !== _package.dwelling.houseDesign.toLowerCase()) {
          _package.filter = true
        }

      })
      return packages
    },

    livingOptionsDwellings: (state, getters, rootState) => {
      const filter = rootState.filter
      let dwellings = JSON.parse(JSON.stringify(state.dwellings))

      dwellings = _.filter(dwellings, dwelling => { return dwelling.active }) // dwelling.isVisibleOnWebfeed

      dwellings.forEach(dwelling => {
        dwelling.filter = false
        
        // filter package price
        if (dwelling.price) {
          const dwellingPrice = dwelling.price / 1000

          if (filter.inputPriceRange[0] > dwellingPrice || filter.inputPriceRange[1] < dwellingPrice) {
            dwelling.filter = true
          }
        }

        // filter dwelling floor size
        if (dwelling.size) {
          const dwellingSize = Number(dwelling.size)
          
          if (filter.inputDwellingSizeRange[0] > dwellingSize || filter.inputDwellingSizeRange[1] < dwellingSize) {
            dwelling.filter = true
          }
        }

        // filter beds
        const packageBeds = parseInt(dwelling.beds)
        if (filter.inputBeds && filter.inputBeds !== packageBeds) {
          dwelling.filter = true
        }

        // filter baths
        const packageBaths = parseInt(dwelling.baths)        
        if (filter.inputBaths && filter.inputBaths !== packageBaths) {
          dwelling.filter = true
        }

        // filter cars
        const packageCars = parseInt(dwelling.cars)
        if (filter.inputCars && filter.inputCars !== packageCars) {
          dwelling.filter = true
        }

        if (filter.inputBuilder && dwelling.builderLabel && filter.inputBuilder.toLowerCase() !== dwelling.builderLabel.toLowerCase()) {
          dwelling.filter = true
        }

        if (filter.inputColourScheme && dwelling.colourScheme && filter.inputColourScheme.toLowerCase() !== dwelling.colourScheme.toLowerCase()) {
          dwelling.filter = true
        }

        if (filter.inputHouseDesign && dwelling.houseDesign && filter.inputHouseDesign.toLowerCase() !== dwelling.houseDesign.toLowerCase()) {
          dwelling.filter = true
        }
      })
      return dwellings
    },

    land: state => {
      if (state.properties.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))
        let land = _.filter(properties, property => property.active && !property.dwelling)

        return land
      }
    },

    townhouses: (state) => {
      if (state.properties.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))
        let townhouses = _.filter(properties, property => property.active && property.dwelling && property.dwelling.type === 'townhouse') 

        return townhouses
      }
    },

    apartments: (state) => {
      if (state.properties.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))
        let apartments = _.filter(properties, property => property.active && property.dwelling && property.dwelling.type === 'apartments') 

        return apartments
      }
    },

    houses: (state) => {
      if (state.properties.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))
        let houses = _.filter(properties, property => property.active && property.dwelling && property.dwelling.type === 'house') 

        return houses
      }
    },

    // Adds some attributes to the raw list of properies, specifically: assigns the model object and filtered state
    properties: (state) => {
      if (state.properties.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))

        // filter out if isEnabled true
        return _.filter(properties, property => property.active)
      } else {
        return []
      }
    },

    dwellings: (state) => {
      if (state.dwellings.length) {
        let dwellings = JSON.parse(JSON.stringify(state.dwellings))

        // filter out if isEnabled true
        dwellings = _.filter(dwellings, dwelling => { return dwelling.active })

        return dwellings
      } else {
        return []
      }
    },

    turnkeys: (state) => {
      return state.turnkeys
    },

    // Returns an array of Subsection objects with their associated Properties nested inside
    // Also sets a "filter" flag to true if all properties have been filtered out
    // Also handles nested subsections
    subsections: (state, getters) => {
      if (getters.properties.length) {
      // Clone subsections from state
        let subsections = JSON.parse(JSON.stringify(state.subsections))

        // filter out if not active
        subsections = _.filter(subsections, subsection => { return subsection.active && !subsection.isVisuallyHidden })

        // Next associated properties
        subsections.forEach(subsection => {
          subsection.matchedPropertiesCount = 0
          let properties = []

          subsection.propertyIds.forEach(propertyId => {
            const property = _.find(getters.properties, property => { return property._id === propertyId })
            if (property) {
              properties.push(property)
              if (!property.filter) {
                subsection.matchedPropertiesCount++
              }
            }
          })

          subsection.properties = properties

          // get count of available properties
          subsection.availableProperties = subsection.properties.filter(property => property.active && property.status !== 'Sold').length

          // start calculating filter ranges
          let bathRanges = []
          let bedRanges = []
          let carRanges = []
          let landPriceRanges = []
          let dwellingPriceRanges = []
          let sizeRanges = []
          let dwellingSizeRanges = []
          let propertyTypes = []
          let lotNumbers = []

          let filter = {
            bathRange: [],
            bedRange: [],
            carRange: [],
            landPriceRange: [],
            dwellingPriceRange: [],
            sizeRange: [],
            dwellingSizeRange: [],
            propertyTypes: [],
            lotNumbers: []
          }

          if (subsection.properties) {
            subsection.properties.forEach(property => {
              if (property.dwelling) {
                bathRanges.push(property.dwelling.baths)
                bedRanges.push(property.dwelling.beds)
                carRanges.push(property.dwelling.cars)
                dwellingPriceRanges.push(property.dwelling.price)
                dwellingSizeRanges.push(property.dwelling.size)
              }

              landPriceRanges.push(property.price)
              sizeRanges.push(property.size)
            })
          }

          // Nest assicated subsections
          if (subsection.subsectionIds && subsection.subsectionIds.length) {
            subsection.subsections = []
            subsection.subsectionIds.forEach(subsectionId => {
              const subSubsection = _.find(subsections, subsection => { return subsection._id === subsectionId })

              if (subSubsection && !subSubsection.isVisuallyHidden) {
                subsection.subsections.push(subSubsection)
              }
            })
          }

          // add child subsections filtering to parent
          if (subsection.subsections) {
            subsection.subsections.forEach(subSubsection => {
              
              bathRanges.push(...subSubsection.filter.bathRange)
              bedRanges.push(...subSubsection.filter.bedRange)
              carRanges.push(...subSubsection.filter.carRange)
              landPriceRanges.push(...subSubsection.filter.landPriceRange)
              dwellingPriceRanges.push(...subSubsection.filter.dwellingPriceRange)
              sizeRanges.push(...subSubsection.filter.sizeRange)
              dwellingSizeRanges.push(...subSubsection.filter.dwellingSizeRange)
              propertyTypes.push(...subSubsection.filter.propertyTypes)
              lotNumbers.push(...subSubsection.filter.lotNumbers)

              filter['bathRange'] = [ Math.min(...bathRanges), Math.max(...bathRanges) ]
              filter['bedRange'] = [ Math.min(...bedRanges), Math.max(...bedRanges) ]
              filter['carRange'] = [ Math.min(...carRanges), Math.max(...carRanges) ]
              filter['landPriceRange'] = [ Math.min(...landPriceRanges), Math.max(...landPriceRanges) ]
              filter['dwellingPriceRange'] = [ Math.min(...dwellingPriceRanges), Math.max(...dwellingPriceRanges) ]
              filter['sizeRange'] = [ Math.min(...sizeRanges), Math.max(...sizeRanges) ]
              filter['dwellingSizeRange'] = [ Math.min(...dwellingSizeRanges), Math.max(...dwellingSizeRanges) ]
              filter['propertyTypes'] = propertyTypes
              filter['lotNumbers'] = lotNumbers
            })

            subsection.filter = filter
          }
        })
        return subsections
      } else {
        return []
      }
    },
  }
}

function recursiveSubsections (subsection, allSubsections) {
  let subsections = []
  let getterSubsection = allSubsections.filter(sub => {
    if (sub._id === subsection._id) {
      return sub
    }
  })[0]

  subsections.push(getterSubsection)

  if (getterSubsection.subsections) {
    getterSubsection.subsections.forEach(sub => {
      subsections.push(...recursiveSubsections(sub, allSubsections))
    })
  }

  return subsections
}
